import { z } from 'zod';

/**
 * What an address may ask the workspace list to do on arrival.
 *
 * `create` exists so a link can open the dialog, which is what the command
 * palette needs: its "New workspace" action used to navigate here and stop,
 * leaving a reader on a page they were already able to reach, wondering what
 * the action had done. The palette deliberately does not open a dialog of its
 * own — one dialog, one owner — so the only way for it to finish the job is to
 * ask the owner.
 *
 * `.catch(undefined)` for the same reason every other search field in this app
 * carries it: an address someone typed or a stale bookmark must land on the
 * page rather than on an error, and a parameter nobody can parse is a parameter
 * nobody asked for.
 */
export const WORKSPACE_TABS = ['yours', 'organization', 'others'] as const;
export type WorkspaceTab = (typeof WORKSPACE_TABS)[number];

export const workspaceListSearchSchema = z.object({
  create: z.boolean().optional().catch(undefined),
  /** The open tab once access divides the list (spec 200); absent = the default. */
  tab: z.enum(WORKSPACE_TABS).optional().catch(undefined),
});

export type WorkspaceListSearch = z.infer<typeof workspaceListSearchSchema>;
